/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Header and back navigation for ViewAppointments.
 * @module pages/viewAppointments/ViewAppointmentsHeader
 */

import LanguageSelector from "../../components/LanguageSelector/index.jsx";
import NotificationBell from "../../components/NotificationBell/index.jsx";
import styles from "../../styles/ViewAppointments.module.css";
import { ReactComponent as ChevronLeftIcon } from "../../assets/icons/BusinessEvents/ChevronLeftIcon.svg";

const ViewAppointmentsHeader = ({
  t,
  navigate,
  eventData,
  onNavigateBack,
}) => (
  <div className={styles.header}>
    <div className={styles.languages}>
      <NotificationBell navigate={navigate} />
      <LanguageSelector />
    </div>

    <div className={styles.backNavigation}>
      <button className={styles.backButton} onClick={onNavigateBack}>
        <ChevronLeftIcon />
        <span>{t("common.goBack")}</span>
      </button>
    </div>

    <div className={styles.headerInfoContainer}>
      <div className={styles.headerInfo}>
        <h1 className={styles.title}>
          {eventData?.nombre || t("pages.viewAppointments.header")}
        </h1>
      </div>
    </div>
  </div>
);

export default ViewAppointmentsHeader;
